// Generated from IfcExpression.g4 by ANTLR 4.13.0
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
	ATN,
	ATNDeserializer, DecisionState, DFA, FailedPredicateException,
	RecognitionException, NoViableAltException, BailErrorStrategy,
	Parser, ParserATNSimulator,
	RuleContext, ParserRuleContext, PredictionMode, PredictionContextCache,
	TerminalNode, RuleNode,
	Token, TokenStream,
	Interval, IntervalSet
} from 'antlr4';
import IfcExpressionListener from "./IfcExpressionListener.js";
import IfcExpressionVisitor from "./IfcExpressionVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;

export default class IfcExpressionParser extends Parser {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly T__5 = 6;
	public static readonly T__6 = 7;
	public static readonly T__7 = 8;
	public static readonly T__8 = 9;
	public static readonly T__9 = 10;
	public static readonly T__10 = 11;
	public static readonly T__11 = 12;
	public static readonly T__12 = 13;
	public static readonly INT = 14;
	public static readonly FLOAT = 15;
	public static readonly BOOLEAN = 16;
	public static readonly LOGICAL_UNKNOWN = 17;
	public static readonly DOT = 18;
	public static readonly QUOTED_STRING = 19;
	public static readonly IDENTIFIER = 20;
	public static readonly WS = 21;
	public static readonly NEWLINE = 22;
	public static readonly BOOLEAN_BINARY_OP = 23;
	public static readonly CMP_OP = 24;
	public static readonly EOF = Token.EOF;
	public static readonly RULE_expr = 0;
	public static readonly RULE_singleExpr = 1;
	public static readonly RULE_methodCallChain = 2;
	public static readonly RULE_functionCall = 3;
	public static readonly RULE_exprList = 4;
	public static readonly RULE_arrayExpr = 5;
	public static readonly RULE_arrayElementList = 6;
	public static readonly RULE_literal = 7;
	public static readonly RULE_numLiteral = 8;
	public static readonly RULE_stringLiteral = 9;
	public static readonly RULE_booleanLiteral = 10;
	public static readonly RULE_logicalLiteral = 11;
	public static readonly RULE_variableRef = 12;
	public static readonly literalNames: (string | null)[] = [ null, "'--'", 
                                                            "'('", "')'", 
                                                            "'-'", "'^'", 
                                                            "'*'", "'/'", 
                                                            "'+'", "'!'", 
                                                            "','", "'['", 
                                                            "']'", "'$'", 
                                                            null, null, 
                                                            null, null, 
                                                            "'.'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             null, null, 
                                                             "INT", "FLOAT", 
                                                             "BOOLEAN", 
                                                             "LOGICAL_UNKNOWN", 
                                                             "DOT", "QUOTED_STRING", 
                                                             "IDENTIFIER", 
                                                             "WS", "NEWLINE", 
                                                             "BOOLEAN_BINARY_OP", 
                                                             "CMP_OP" ];
	// tslint:disable:no-trailing-whitespace
	public static readonly ruleNames: string[] = [
		"expr", "singleExpr", "methodCallChain", "functionCall", "exprList", "arrayExpr", 
		"arrayElementList", "literal", "numLiteral", "stringLiteral", "booleanLiteral", 
		"logicalLiteral", "variableRef",
	];
	public get grammarFileName(): string { return "IfcExpression.g4"; }
	public get literalNames(): (string | null)[] { return IfcExpressionParser.literalNames; }
	public get symbolicNames(): (string | null)[] { return IfcExpressionParser.symbolicNames; }
	public get ruleNames(): string[] { return IfcExpressionParser.ruleNames; }
	public get serializedATN(): number[] { return IfcExpressionParser._serializedATN; }

	protected createFailedPredicateException(predicate?: string, message?: string): FailedPredicateException {
		return new FailedPredicateException(this, predicate, message);
	}

	constructor(input: TokenStream) {
		super(input);
		this._interp = new ParserATNSimulator(this, IfcExpressionParser._ATN, IfcExpressionParser.DecisionsToDFA, new PredictionContextCache());
	}
	// @RuleVersion(0)
	public expr(): ExprContext {
		let localctx: ExprContext = new ExprContext(this, this._ctx, this.state);
		this.enterRule(localctx, 0, IfcExpressionParser.RULE_expr);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 26;
			this.singleExpr(0);
			this.state = 27;
			this.match(IfcExpressionParser.EOF);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public singleExpr(): SingleExprContext;
	public singleExpr(_p: number): SingleExprContext;
	// @RuleVersion(0)
	public singleExpr(_p?: number): SingleExprContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: SingleExprContext = new SingleExprContext(this, this._ctx, _parentState);
		let _prevctx: SingleExprContext = localctx;
		let _startState: number = 2;
		this.enterRecursionRule(localctx, 2, IfcExpressionParser.RULE_singleExpr, _p);
		let _la: number;
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 44;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 1:
				{
				localctx = new SEUnaryMultipleMinusContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;

				this.state = 30;
				this.match(IfcExpressionParser.T__0);
				this.state = 31;
				(localctx as SEUnaryMultipleMinusContext)._sub = this.singleExpr(14);
				}
				break;
			case 2:
				{
				localctx = new SEParenthesisContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 32;
				this.match(IfcExpressionParser.T__1);
				this.state = 33;
				(localctx as SEParenthesisContext)._sub = this.singleExpr(0);
				this.state = 34;
				this.match(IfcExpressionParser.T__2);
				}
				break;
			case 4:
				{
				localctx = new SEUnaryMinusContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 36;
				this.match(IfcExpressionParser.T__3);
				this.state = 37;
				(localctx as SEUnaryMinusContext)._sub = this.singleExpr(12);
				}
				break;
			case 9:
				{
				localctx = new SENotContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 38;
				this.match(IfcExpressionParser.T__8);
				this.state = 39;
				(localctx as SENotContext)._sub = this.singleExpr(6);
				}
				break;
			case 13:
				{
				localctx = new SEVariableRefContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 40;
				(localctx as SEVariableRefContext)._sub = this.variableRef();
				}
				break;
			case 20:
				{
				localctx = new SEFunctionCallContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 41;
				(localctx as SEFunctionCallContext)._sub = this.functionCall();
				}
				break;
			case 14:
			case 15:
			case 16:
			case 17:
			case 19:
				{
				localctx = new SELiteralContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 42;
				(localctx as SELiteralContext)._sub = this.literal();
				}
				break;
			case 11:
				{
				localctx = new SEArrayExprContext(this, localctx);
				this._ctx = localctx;
				_prevctx = localctx;
				this.state = 43;
				(localctx as SEArrayExprContext)._sub = this.arrayExpr();
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 65;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 63;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 1, this._ctx) ) {
					case 1:
						{
						localctx = new SEPowerContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEPowerContext)._left = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 46;
						if (!(this.precpred(this._ctx, 11))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 11)");
						}
						this.state = 47;
						(localctx as SEPowerContext)._op = this.match(IfcExpressionParser.T__4);
						this.state = 48;
						(localctx as SEPowerContext)._right = this.singleExpr(11);
						}
						break;
					case 2:
						{
						localctx = new SEMulDivContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEMulDivContext)._left = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 49;
						if (!(this.precpred(this._ctx, 9))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 9)");
						}
						this.state = 50;
						(localctx as SEMulDivContext)._op = this._input.LT(1);
						_la = this._input.LA(1);
						if(!(_la===6 || _la===7)) {
						    (localctx as SEMulDivContext)._op = this._errHandler.recoverInline(this);
						}
						else {
							this._errHandler.reportMatch(this);
						    this.consume();
						}
						this.state = 51;
						(localctx as SEMulDivContext)._right = this.singleExpr(10);
						}
						break;
					case 3:
						{
						localctx = new SEAddSubContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEAddSubContext)._left = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 52;
						if (!(this.precpred(this._ctx, 8))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 8)");
						}
						this.state = 53;
						(localctx as SEAddSubContext)._op = this._input.LT(1);
						_la = this._input.LA(1);
						if(!(_la===4 || _la===8)) {
						    (localctx as SEAddSubContext)._op = this._errHandler.recoverInline(this);
						}
						else {
							this._errHandler.reportMatch(this);
						    this.consume();
						}
						this.state = 54;
						(localctx as SEAddSubContext)._right = this.singleExpr(9);
						}
						break;
					case 4:
						{
						localctx = new SEComparisonContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEComparisonContext)._left = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 55;
						if (!(this.precpred(this._ctx, 7))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 7)");
						}
						this.state = 56;
						this.match(IfcExpressionParser.CMP_OP);
						this.state = 57;
						(localctx as SEComparisonContext)._right = this.singleExpr(8);
						}
						break;
					case 5:
						{
						localctx = new SEBooleanBinaryOpContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEBooleanBinaryOpContext)._left = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 58;
						if (!(this.precpred(this._ctx, 5))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 5)");
						}
						this.state = 59;
						(localctx as SEBooleanBinaryOpContext)._op = this.match(IfcExpressionParser.BOOLEAN_BINARY_OP);
						this.state = 60;
						(localctx as SEBooleanBinaryOpContext)._right = this.singleExpr(6);
						}
						break;
					case 6:
						{
						localctx = new SEMethodCallContext(this, new SingleExprContext(this, _parentctx, _parentState));
						(localctx as SEMethodCallContext)._target = _prevctx;
						this.pushNewRecursionContext(localctx, _startState, IfcExpressionParser.RULE_singleExpr);
						this.state = 61;
						if (!(this.precpred(this._ctx, 10))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 10)");
						}
						this.state = 62;
						(localctx as SEMethodCallContext)._call = this.methodCallChain();
						}
						break;
					}
					}
				}
				this.state = 67;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}
	// @RuleVersion(0)
	public methodCallChain(): MethodCallChainContext {
		let localctx: MethodCallChainContext = new MethodCallChainContext(this, this._ctx, this.state);
		this.enterRule(localctx, 4, IfcExpressionParser.RULE_methodCallChain);
		try {
			this.state = 74;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 3, this._ctx) ) {
			case 1:
				localctx = new MethodCallChainInnerContext(this, localctx);
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 68;
				this.match(IfcExpressionParser.DOT);
				this.state = 69;
				(localctx as MethodCallChainInnerContext)._target = this.functionCall();
				this.state = 70;
				(localctx as MethodCallChainInnerContext)._call = this.methodCallChain();
				}
				break;
			case 2:
				localctx = new MethodCallChainEndContext(this, localctx);
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 72;
				this.match(IfcExpressionParser.DOT);
				this.state = 73;
				(localctx as MethodCallChainEndContext)._call = this.functionCall();
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public functionCall(): FunctionCallContext {
		let localctx: FunctionCallContext = new FunctionCallContext(this, this._ctx, this.state);
		this.enterRule(localctx, 6, IfcExpressionParser.RULE_functionCall);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 76;
			this.match(IfcExpressionParser.IDENTIFIER);
			this.state = 77;
			this.match(IfcExpressionParser.T__1);
			this.state = 79;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 1829398) !== 0)) {
				{
				this.state = 78;
				localctx._sub = this.exprList();
				}
			}

			this.state = 81;
			this.match(IfcExpressionParser.T__2);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public exprList(): ExprListContext {
		let localctx: ExprListContext = new ExprListContext(this, this._ctx, this.state);
		this.enterRule(localctx, 8, IfcExpressionParser.RULE_exprList);
		try {
			this.state = 88;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 5, this._ctx) ) {
			case 1:
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 83;
				this.singleExpr(0);
				}
				break;
			case 2:
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 84;
				this.singleExpr(0);
				this.state = 85;
				this.match(IfcExpressionParser.T__9);
				this.state = 86;
				this.exprList();
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public arrayExpr(): ArrayExprContext {
		let localctx: ArrayExprContext = new ArrayExprContext(this, this._ctx, this.state);
		this.enterRule(localctx, 10, IfcExpressionParser.RULE_arrayExpr);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 90;
			this.match(IfcExpressionParser.T__10);
			this.state = 92;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 1829398) !== 0)) {
				{
				this.state = 91;
				localctx._sub = this.arrayElementList();
				}
			}

			this.state = 94;
			this.match(IfcExpressionParser.T__11);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public arrayElementList(): ArrayElementListContext {
		let localctx: ArrayElementListContext = new ArrayElementListContext(this, this._ctx, this.state);
		this.enterRule(localctx, 12, IfcExpressionParser.RULE_arrayElementList);
		try {
			this.state = 101;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 7, this._ctx) ) {
			case 1:
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 96;
				this.singleExpr(0);
				}
				break;
			case 2:
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 97;
				this.singleExpr(0);
				this.state = 98;
				this.match(IfcExpressionParser.T__9);
				this.state = 99;
				this.arrayElementList();
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public literal(): LiteralContext {
		let localctx: LiteralContext = new LiteralContext(this, this._ctx, this.state);
		this.enterRule(localctx, 14, IfcExpressionParser.RULE_literal);
		try {
			this.state = 107;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case 14:
			case 15:
				this.enterOuterAlt(localctx, 1);
				{
				this.state = 103;
				this.numLiteral();
				}
				break;
			case 19:
				this.enterOuterAlt(localctx, 2);
				{
				this.state = 104;
				this.stringLiteral();
				}
				break;
			case 16:
				this.enterOuterAlt(localctx, 3);
				{
				this.state = 105;
				this.booleanLiteral();
				}
				break;
			case 17:
				this.enterOuterAlt(localctx, 4);
				{
				this.state = 106;
				this.logicalLiteral();
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public numLiteral(): NumLiteralContext {
		let localctx: NumLiteralContext = new NumLiteralContext(this, this._ctx, this.state);
		this.enterRule(localctx, 16, IfcExpressionParser.RULE_numLiteral);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 109;
			_la = this._input.LA(1);
			if(!(_la===14 || _la===15)) {
			this._errHandler.recoverInline(this);
			}
			else {
				this._errHandler.reportMatch(this);
			    this.consume();
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public stringLiteral(): StringLiteralContext {
		let localctx: StringLiteralContext = new StringLiteralContext(this, this._ctx, this.state);
		this.enterRule(localctx, 18, IfcExpressionParser.RULE_stringLiteral);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 111;
			this.match(IfcExpressionParser.QUOTED_STRING);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public booleanLiteral(): BooleanLiteralContext {
		let localctx: BooleanLiteralContext = new BooleanLiteralContext(this, this._ctx, this.state);
		this.enterRule(localctx, 20, IfcExpressionParser.RULE_booleanLiteral);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 113;
			this.match(IfcExpressionParser.BOOLEAN);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public logicalLiteral(): LogicalLiteralContext {
		let localctx: LogicalLiteralContext = new LogicalLiteralContext(this, this._ctx, this.state);
		this.enterRule(localctx, 22, IfcExpressionParser.RULE_logicalLiteral);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 115;
			this.match(IfcExpressionParser.LOGICAL_UNKNOWN);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public variableRef(): VariableRefContext {
		let localctx: VariableRefContext = new VariableRefContext(this, this._ctx, this.state);
		this.enterRule(localctx, 24, IfcExpressionParser.RULE_variableRef);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 117;
			this.match(IfcExpressionParser.T__12);
			this.state = 118;
			this.match(IfcExpressionParser.IDENTIFIER);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public sempred(localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
		switch (ruleIndex) {
		case 1:
			return this.singleExpr_sempred(localctx as SingleExprContext, predIndex);
		}
		return true;
	}
	private singleExpr_sempred(localctx: SingleExprContext, predIndex: number): boolean {
		switch (predIndex) {
		case 0:
			return this.precpred(this._ctx, 11);
		case 1:
			return this.precpred(this._ctx, 9);
		case 2:
			return this.precpred(this._ctx, 8);
		case 3:
			return this.precpred(this._ctx, 7);
		case 4:
			return this.precpred(this._ctx, 5);
		case 5:
			return this.precpred(this._ctx, 10);
		}
		return true;
	}

	public static readonly _serializedATN: number[] = [4,1,24,121,2,0,7,0,2,
	1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,
	10,7,10,2,11,7,11,2,12,7,12,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
	1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,45,8,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
	1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,5,1,64,8,1,10,1,12,1,67,9,1,1,2,1,2,
	1,2,1,2,1,2,1,2,3,2,75,8,2,1,3,1,3,1,3,3,3,80,8,3,1,3,1,3,1,4,1,4,1,4,1,
	4,1,4,3,4,89,8,4,1,5,1,5,3,5,93,8,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,3,6,102,
	8,6,1,7,1,7,1,7,1,7,3,7,108,8,7,1,8,1,8,1,9,1,9,1,10,1,10,1,11,1,11,1,12,
	1,12,1,12,1,12,0,1,2,13,0,2,4,6,8,10,12,14,16,18,20,22,24,0,3,1,0,6,7,2,
	0,4,4,8,8,1,0,14,15,128,0,26,1,0,0,0,2,44,1,0,0,0,4,74,1,0,0,0,6,76,1,0,
	0,0,8,88,1,0,0,0,10,90,1,0,0,0,12,101,1,0,0,0,14,107,1,0,0,0,16,109,1,0,
	0,0,18,111,1,0,0,0,20,113,1,0,0,0,22,115,1,0,0,0,24,117,1,0,0,0,26,27,3,
	2,1,0,27,28,5,0,0,1,28,1,1,0,0,0,29,30,6,1,-1,0,30,31,5,1,0,0,31,45,3,2,
	1,14,32,33,5,2,0,0,33,34,3,2,1,0,34,35,5,3,0,0,35,45,1,0,0,0,36,37,5,4,
	0,0,37,45,3,2,1,12,38,39,5,9,0,0,39,45,3,2,1,6,40,45,3,24,12,0,41,45,3,
	6,3,0,42,45,3,14,7,0,43,45,3,10,5,0,44,29,1,0,0,0,44,32,1,0,0,0,44,36,1,
	0,0,0,44,38,1,0,0,0,44,40,1,0,0,0,44,41,1,0,0,0,44,42,1,0,0,0,44,43,1,0,
	0,0,45,65,1,0,0,0,46,47,10,11,0,0,47,48,5,5,0,0,48,64,3,2,1,11,49,50,10,
	9,0,0,50,51,7,0,0,0,51,64,3,2,1,10,52,53,10,8,0,0,53,54,7,1,0,0,54,64,3,
	2,1,9,55,56,10,7,0,0,56,57,5,24,0,0,57,64,3,2,1,8,58,59,10,5,0,0,59,60,
	5,23,0,0,60,64,3,2,1,6,61,62,10,10,0,0,62,64,3,4,2,0,63,46,1,0,0,0,63,49,
	1,0,0,0,63,52,1,0,0,0,63,55,1,0,0,0,63,58,1,0,0,0,63,61,1,0,0,0,64,67,1,
	0,0,0,65,63,1,0,0,0,65,66,1,0,0,0,66,3,1,0,0,0,67,65,1,0,0,0,68,69,5,18,
	0,0,69,70,3,6,3,0,70,71,3,4,2,0,71,75,1,0,0,0,72,73,5,18,0,0,73,75,3,6,
	3,0,74,68,1,0,0,0,74,72,1,0,0,0,75,5,1,0,0,0,76,77,5,20,0,0,77,79,5,2,0,
	0,78,80,3,8,4,0,79,78,1,0,0,0,79,80,1,0,0,0,80,81,1,0,0,0,81,82,5,3,0,0,
	82,7,1,0,0,0,83,89,3,2,1,0,84,85,3,2,1,0,85,86,5,10,0,0,86,87,3,8,4,0,87,
	89,1,0,0,0,88,83,1,0,0,0,88,84,1,0,0,0,89,9,1,0,0,0,90,92,5,11,0,0,91,93,
	3,12,6,0,92,91,1,0,0,0,92,93,1,0,0,0,93,94,1,0,0,0,94,95,5,12,0,0,95,11,
	1,0,0,0,96,102,3,2,1,0,97,98,3,2,1,0,98,99,5,10,0,0,99,100,3,12,6,0,100,
	102,1,0,0,0,101,96,1,0,0,0,101,97,1,0,0,0,102,13,1,0,0,0,103,108,3,16,8,
	0,104,108,3,18,9,0,105,108,3,20,10,0,106,108,3,22,11,0,107,103,1,0,0,0,
	107,104,1,0,0,0,107,105,1,0,0,0,107,106,1,0,0,0,108,15,1,0,0,0,109,110,
	7,2,0,0,110,17,1,0,0,0,111,112,5,19,0,0,112,19,1,0,0,0,113,114,5,16,0,0,
	114,21,1,0,0,0,115,116,5,17,0,0,116,23,1,0,0,0,117,118,5,13,0,0,118,119,
	5,20,0,0,119,25,1,0,0,0,9,44,63,65,74,79,88,92,101,107];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!IfcExpressionParser.__ATN) {
			IfcExpressionParser.__ATN = new ATNDeserializer().deserialize(IfcExpressionParser._serializedATN);
		}

		return IfcExpressionParser.__ATN;
	}


	static DecisionsToDFA = IfcExpressionParser._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );

}

export class ExprContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public EOF(): TerminalNode {
		return this.getToken(IfcExpressionParser.EOF, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_expr;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterExpr) {
	 		listener.enterExpr(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitExpr) {
	 		listener.exitExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitExpr) {
			return visitor.visitExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class SingleExprContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_singleExpr;
	}
	public copyFrom(ctx: SingleExprContext): void {
		super.copyFrom(ctx);
	}
}
export class SEComparisonContext extends SingleExprContext {
	public _left!: SingleExprContext;
	public _right!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public CMP_OP(): TerminalNode {
		return this.getToken(IfcExpressionParser.CMP_OP, 0);
	}
	public singleExpr_list(): SingleExprContext[] {
		return this.getTypedRuleContexts(SingleExprContext) as SingleExprContext[];
	}
	public singleExpr(i: number): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, i) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEComparison) {
	 		listener.enterSEComparison(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEComparison) {
	 		listener.exitSEComparison(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEComparison) {
			return visitor.visitSEComparison(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SELiteralContext extends SingleExprContext {
	public _sub!: LiteralContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public literal(): LiteralContext {
		return this.getTypedRuleContext(LiteralContext, 0) as LiteralContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSELiteral) {
	 		listener.enterSELiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSELiteral) {
	 		listener.exitSELiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSELiteral) {
			return visitor.visitSELiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEParenthesisContext extends SingleExprContext {
	public _sub!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEParenthesis) {
	 		listener.enterSEParenthesis(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEParenthesis) {
	 		listener.exitSEParenthesis(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEParenthesis) {
			return visitor.visitSEParenthesis(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEMulDivContext extends SingleExprContext {
	public _left!: SingleExprContext;
	public _op!: Token;
	public _right!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr_list(): SingleExprContext[] {
		return this.getTypedRuleContexts(SingleExprContext) as SingleExprContext[];
	}
	public singleExpr(i: number): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, i) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEMulDiv) {
	 		listener.enterSEMulDiv(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEMulDiv) {
	 		listener.exitSEMulDiv(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEMulDiv) {
			return visitor.visitSEMulDiv(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEPowerContext extends SingleExprContext {
	public _left!: SingleExprContext;
	public _op!: Token;
	public _right!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr_list(): SingleExprContext[] {
		return this.getTypedRuleContexts(SingleExprContext) as SingleExprContext[];
	}
	public singleExpr(i: number): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, i) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEPower) {
	 		listener.enterSEPower(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEPower) {
	 		listener.exitSEPower(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEPower) {
			return visitor.visitSEPower(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEBooleanBinaryOpContext extends SingleExprContext {
	public _left!: SingleExprContext;
	public _op!: Token;
	public _right!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr_list(): SingleExprContext[] {
		return this.getTypedRuleContexts(SingleExprContext) as SingleExprContext[];
	}
	public singleExpr(i: number): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, i) as SingleExprContext;
	}
	public BOOLEAN_BINARY_OP(): TerminalNode {
		return this.getToken(IfcExpressionParser.BOOLEAN_BINARY_OP, 0);
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEBooleanBinaryOp) {
	 		listener.enterSEBooleanBinaryOp(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEBooleanBinaryOp) {
	 		listener.exitSEBooleanBinaryOp(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEBooleanBinaryOp) {
			return visitor.visitSEBooleanBinaryOp(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEFunctionCallContext extends SingleExprContext {
	public _sub!: FunctionCallContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public functionCall(): FunctionCallContext {
		return this.getTypedRuleContext(FunctionCallContext, 0) as FunctionCallContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEFunctionCall) {
	 		listener.enterSEFunctionCall(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEFunctionCall) {
	 		listener.exitSEFunctionCall(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEFunctionCall) {
			return visitor.visitSEFunctionCall(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEArrayExprContext extends SingleExprContext {
	public _sub!: ArrayExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public arrayExpr(): ArrayExprContext {
		return this.getTypedRuleContext(ArrayExprContext, 0) as ArrayExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEArrayExpr) {
	 		listener.enterSEArrayExpr(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEArrayExpr) {
	 		listener.exitSEArrayExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEArrayExpr) {
			return visitor.visitSEArrayExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SENotContext extends SingleExprContext {
	public _sub!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSENot) {
	 		listener.enterSENot(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSENot) {
	 		listener.exitSENot(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSENot) {
			return visitor.visitSENot(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEVariableRefContext extends SingleExprContext {
	public _sub!: VariableRefContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public variableRef(): VariableRefContext {
		return this.getTypedRuleContext(VariableRefContext, 0) as VariableRefContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEVariableRef) {
	 		listener.enterSEVariableRef(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEVariableRef) {
	 		listener.exitSEVariableRef(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEVariableRef) {
			return visitor.visitSEVariableRef(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEUnaryMultipleMinusContext extends SingleExprContext {
	public _sub!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEUnaryMultipleMinus) {
	 		listener.enterSEUnaryMultipleMinus(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEUnaryMultipleMinus) {
	 		listener.exitSEUnaryMultipleMinus(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEUnaryMultipleMinus) {
			return visitor.visitSEUnaryMultipleMinus(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEUnaryMinusContext extends SingleExprContext {
	public _sub!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEUnaryMinus) {
	 		listener.enterSEUnaryMinus(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEUnaryMinus) {
	 		listener.exitSEUnaryMinus(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEUnaryMinus) {
			return visitor.visitSEUnaryMinus(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEAddSubContext extends SingleExprContext {
	public _left!: SingleExprContext;
	public _op!: Token;
	public _right!: SingleExprContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr_list(): SingleExprContext[] {
		return this.getTypedRuleContexts(SingleExprContext) as SingleExprContext[];
	}
	public singleExpr(i: number): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, i) as SingleExprContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEAddSub) {
	 		listener.enterSEAddSub(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEAddSub) {
	 		listener.exitSEAddSub(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEAddSub) {
			return visitor.visitSEAddSub(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SEMethodCallContext extends SingleExprContext {
	public _target!: SingleExprContext;
	public _call!: MethodCallChainContext;
	constructor(parser: IfcExpressionParser, ctx: SingleExprContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public methodCallChain(): MethodCallChainContext {
		return this.getTypedRuleContext(MethodCallChainContext, 0) as MethodCallChainContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterSEMethodCall) {
	 		listener.enterSEMethodCall(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitSEMethodCall) {
	 		listener.exitSEMethodCall(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitSEMethodCall) {
			return visitor.visitSEMethodCall(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class MethodCallChainContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_methodCallChain;
	}
	public copyFrom(ctx: MethodCallChainContext): void {
		super.copyFrom(ctx);
	}
}
export class MethodCallChainInnerContext extends MethodCallChainContext {
	public _target!: FunctionCallContext;
	public _call!: MethodCallChainContext;
	constructor(parser: IfcExpressionParser, ctx: MethodCallChainContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public DOT(): TerminalNode {
		return this.getToken(IfcExpressionParser.DOT, 0);
	}
	public functionCall(): FunctionCallContext {
		return this.getTypedRuleContext(FunctionCallContext, 0) as FunctionCallContext;
	}
	public methodCallChain(): MethodCallChainContext {
		return this.getTypedRuleContext(MethodCallChainContext, 0) as MethodCallChainContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterMethodCallChainInner) {
	 		listener.enterMethodCallChainInner(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitMethodCallChainInner) {
	 		listener.exitMethodCallChainInner(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitMethodCallChainInner) {
			return visitor.visitMethodCallChainInner(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class MethodCallChainEndContext extends MethodCallChainContext {
	public _call!: FunctionCallContext;
	constructor(parser: IfcExpressionParser, ctx: MethodCallChainContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public DOT(): TerminalNode {
		return this.getToken(IfcExpressionParser.DOT, 0);
	}
	public functionCall(): FunctionCallContext {
		return this.getTypedRuleContext(FunctionCallContext, 0) as FunctionCallContext;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterMethodCallChainEnd) {
	 		listener.enterMethodCallChainEnd(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitMethodCallChainEnd) {
	 		listener.exitMethodCallChainEnd(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitMethodCallChainEnd) {
			return visitor.visitMethodCallChainEnd(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class FunctionCallContext extends ParserRuleContext {
	public _sub!: ExprListContext;
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public IDENTIFIER(): TerminalNode {
		return this.getToken(IfcExpressionParser.IDENTIFIER, 0);
	}
	public exprList(): ExprListContext {
		return this.getTypedRuleContext(ExprListContext, 0) as ExprListContext;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_functionCall;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterFunctionCall) {
	 		listener.enterFunctionCall(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitFunctionCall) {
	 		listener.exitFunctionCall(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitFunctionCall) {
			return visitor.visitFunctionCall(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ExprListContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public exprList(): ExprListContext {
		return this.getTypedRuleContext(ExprListContext, 0) as ExprListContext;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_exprList;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterExprList) {
	 		listener.enterExprList(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitExprList) {
	 		listener.exitExprList(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitExprList) {
			return visitor.visitExprList(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ArrayExprContext extends ParserRuleContext {
	public _sub!: ArrayElementListContext;
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public arrayElementList(): ArrayElementListContext {
		return this.getTypedRuleContext(ArrayElementListContext, 0) as ArrayElementListContext;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_arrayExpr;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterArrayExpr) {
	 		listener.enterArrayExpr(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitArrayExpr) {
	 		listener.exitArrayExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitArrayExpr) {
			return visitor.visitArrayExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ArrayElementListContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public singleExpr(): SingleExprContext {
		return this.getTypedRuleContext(SingleExprContext, 0) as SingleExprContext;
	}
	public arrayElementList(): ArrayElementListContext {
		return this.getTypedRuleContext(ArrayElementListContext, 0) as ArrayElementListContext;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_arrayElementList;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterArrayElementList) {
	 		listener.enterArrayElementList(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitArrayElementList) {
	 		listener.exitArrayElementList(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitArrayElementList) {
			return visitor.visitArrayElementList(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class LiteralContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public numLiteral(): NumLiteralContext {
		return this.getTypedRuleContext(NumLiteralContext, 0) as NumLiteralContext;
	}
	public stringLiteral(): StringLiteralContext {
		return this.getTypedRuleContext(StringLiteralContext, 0) as StringLiteralContext;
	}
	public booleanLiteral(): BooleanLiteralContext {
		return this.getTypedRuleContext(BooleanLiteralContext, 0) as BooleanLiteralContext;
	}
	public logicalLiteral(): LogicalLiteralContext {
		return this.getTypedRuleContext(LogicalLiteralContext, 0) as LogicalLiteralContext;
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_literal;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterLiteral) {
	 		listener.enterLiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitLiteral) {
	 		listener.exitLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitLiteral) {
			return visitor.visitLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class NumLiteralContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public INT(): TerminalNode {
		return this.getToken(IfcExpressionParser.INT, 0);
	}
	public FLOAT(): TerminalNode {
		return this.getToken(IfcExpressionParser.FLOAT, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_numLiteral;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterNumLiteral) {
	 		listener.enterNumLiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitNumLiteral) {
	 		listener.exitNumLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitNumLiteral) {
			return visitor.visitNumLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class StringLiteralContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public QUOTED_STRING(): TerminalNode {
		return this.getToken(IfcExpressionParser.QUOTED_STRING, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_stringLiteral;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterStringLiteral) {
	 		listener.enterStringLiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitStringLiteral) {
	 		listener.exitStringLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitStringLiteral) {
			return visitor.visitStringLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class BooleanLiteralContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public BOOLEAN(): TerminalNode {
		return this.getToken(IfcExpressionParser.BOOLEAN, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_booleanLiteral;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterBooleanLiteral) {
	 		listener.enterBooleanLiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitBooleanLiteral) {
	 		listener.exitBooleanLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitBooleanLiteral) {
			return visitor.visitBooleanLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class LogicalLiteralContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public LOGICAL_UNKNOWN(): TerminalNode {
		return this.getToken(IfcExpressionParser.LOGICAL_UNKNOWN, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_logicalLiteral;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterLogicalLiteral) {
	 		listener.enterLogicalLiteral(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitLogicalLiteral) {
	 		listener.exitLogicalLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitLogicalLiteral) {
			return visitor.visitLogicalLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class VariableRefContext extends ParserRuleContext {
	constructor(parser?: IfcExpressionParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public IDENTIFIER(): TerminalNode {
		return this.getToken(IfcExpressionParser.IDENTIFIER, 0);
	}
    public get ruleIndex(): number {
    	return IfcExpressionParser.RULE_variableRef;
	}
	public enterRule(listener: IfcExpressionListener): void {
	    if(listener.enterVariableRef) {
	 		listener.enterVariableRef(this);
		}
	}
	public exitRule(listener: IfcExpressionListener): void {
	    if(listener.exitVariableRef) {
	 		listener.exitVariableRef(this);
		}
	}
	// @Override
	public accept<Result>(visitor: IfcExpressionVisitor<Result>): Result {
		if (visitor.visitVariableRef) {
			return visitor.visitVariableRef(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
